import HRLeaveApproval from '../hr/LeaveApproval';
export default HRLeaveApproval;
